// src/components/navbar/ui/NavbarBrand.jsx

import React from "react";
import { cn } from "../utils/navbarUtils";
import { NAVBAR_CONFIG } from "../data/navbarTheme";

export default function NavbarBrand({
  onClick,
  transparent = false,
  compact = false,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "group inline-flex items-center gap-3",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-4",
        transparent
          ? "focus-visible:ring-white focus-visible:ring-offset-slate-900"
          : "focus-visible:ring-[#0868f2] focus-visible:ring-offset-white",
      )}
      aria-label="Revenir à l’accueil de MonAppliClub"
    >
      <img
        src={NAVBAR_CONFIG.logo}
        alt=""
        className={cn(
          "shrink-0 object-contain transition-transform duration-300",
          "drop-shadow-[0_4px_12px_rgba(15,23,42,0.18)]",
          compact ? "h-9 w-12" : "h-11 w-[58px]",
          "group-hover:scale-[1.04]",
        )}
      />

      {!compact && (
        <div className="hidden text-left leading-none sm:block">
          <div className="flex items-baseline">
            <span
              className={cn(
                "font-passionOne text-[1.9rem] leading-none transition-colors",
                transparent
                  ? "text-white"
                  : "text-[#0868f2] dark:text-[#66a3ff]",
              )}
            >
              MonAppli
            </span>

            <span className="font-passionOne text-[1.9rem] leading-none text-[#ff7900]">
              Club
            </span>
          </div>

          <p
            className={cn(
              "mt-0.5 text-[9px] font-semibold uppercase tracking-[0.24em]",
              transparent
                ? "text-white/65"
                : "text-slate-500 dark:text-slate-400",
            )}
          >
            Des outils conçus pour le terrain
          </p>
        </div>
      )}
    </button>
  );
}